import { render } from "./importPre.vue?vue&type=template&id=07791b80&scoped=true"
import script from "./importPre.vue?vue&type=script&lang=js"
export * from "./importPre.vue?vue&type=script&lang=js"

import "./importPre.vue?vue&type=style&index=0&id=07791b80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-07791b80"

export default script